import "./Common/Dialogs.api";
export { DialogDesktop } from "./Desktop/DialogDesktop.container";
export { DialogMobile } from "./Mobile/DialogMobile.container";

export type DialogActions =
  | "dialog.show"
  | "dialog.hide"
  | "dialog.title.set"
  | "dialog.message.set"
  | "dialog.buttons.set"
  | "dialog.cover.set"
  | "dialog.centermessage.set";
